'use client';

import { useRouteLogic } from '../hooks/useRouteLogic';

interface RouteLogicProviderProps {
  children: (showBonusOnRoute: boolean) => React.ReactNode;
}

export const RouteLogicProvider = ({ children }: RouteLogicProviderProps) => {
  const { showBonusOnRoute } = useRouteLogic();

  return <>{children(showBonusOnRoute)}</>;
};
